export class DynamoDBFilter {
  constructor(public AttributeNaam: string, public AttributeFilterExpression: string ) { }
}